import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbService } from './breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class BreadcrumbInitializedGuard  {

  constructor(private service: BreadcrumbService,
              private translate: TranslateService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const crumbs = route.data.crumbs as MenuItem[];
    crumbs.map(item => item.label = this.translate.instant(item.label));
    if (crumbs.length > 0) {
      const lastIndex = crumbs.length - 1;
      crumbs[lastIndex].routerLink = state.url;
      // this.translate.get(route.data['title']).subscribe(res => {
      //   crumbs[lastIndex].label = res;
      // });
    }
    this.service.setCrumbs(crumbs);
    return true;
  }
}
